export default __webpack_public_path__ + "static/media/iconCardWatch.20473993.svg";